export interface IScreen {
    deviceId: string;
    serial_number: string;
    error?: { type: 'ELEVEIGHT' | 'KONE' | 'MEDUSA'; message: string };
    ken?: string;
    functionalLocation?: string;
    edaVersion?: string;
    eloVersion?: string;
    androidBrand?: string;
    language?: string;
    cop?: string;
    copPosition?: string;
    linked: boolean;
    model?: string;
    location?: string;
    orientation?: string;
    networkType?: string;
    cmsUrl?: string;
    screenSize: number;
    name?: string;
    contractStartDate?: string;
    contractEndDate?: string;
    activeContract: boolean;
    data?: string;
    shadowKen: boolean;
    active?: boolean;
    displayType: EDisplayType;
    venueId?: string;
    status?: EDisplayStatus;
    lastSeenAt?: string;
    contentSummary?: string;
    visionEnabled?: boolean;
    referenceUrl?: string;
    operatingSystem?: string;
    macAddress?: string;
    iccid?: string;
    firmwareVersion?: string;
    connectivityMethod?: string;
    cameraType?: string;
    resolution?: string;
    locationDetail?: string;
    contentAreaWidth?: number;
    contentAreaHeight?: number;
}

export interface IElevEightScreenDto {
    venue_id?: string;
    name?: string;
    model?: string;
    url?: string;
    content_summary?: string;
    last_seen_at?: string;
    status?: EDisplayStatus;
    custom_attributes: {
        connectivity_method?: string;
        vision_enabled?: boolean | null;
        camera_type?: string;
        mac_address?: string;
        iccid?: string;
        firmware_version?: string;
        operating_system?: string;
        reference_url?: string;
    };
    advertising_attributes: {
        location?: string;
        location_detail?: string;
        screen_size: number;
        resolution?: string;
        content_area_height?: number | null;
        content_area_width?: number | null;
        orientation?: string;
    };
}

/* ========= DTO ========= */
export interface IScreenDto {
    device_id: string;
    serial_number: string;
    error?: { type: 'ELEVEIGHT' | 'KONE' | 'MEDUSA'; message: string };
    ken?: string;
    functional_location?: string;
    eda_version?: string;
    elo_version?: string;
    android_brand?: string;
    language?: string;
    cop?: string;
    cop_position?: string;
    eleveight: IElevEightScreenDto;
    linked: boolean;
    displayType: EDisplayType;
    active?: boolean;
}

export enum EDisplayType {
    Device,
    ElevEight,
}

export enum EDisplayStatus {
    Created,
    Active,
    Idle,
    Offline,
    Deactivated,
}
